import { configureStore } from "@reduxjs/toolkit";
import reducer from "../stores/index";
import { persistStore } from "redux-persist";

// Create Redux Store with Reducers
export const store = configureStore({
  reducer,
});

export const persistor = persistStore(store);

export default { store, persistor };
